import { render, staticRenderFns } from "./stockMoveTask.vue?vue&type=template&id=4c5f9f5d&scoped=true"
import script from "./stockMoveTask.vue?vue&type=script&lang=js"
export * from "./stockMoveTask.vue?vue&type=script&lang=js"
import style0 from "./stockMoveTask.vue?vue&type=style&index=0&id=4c5f9f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5f9f5d",
  null
  
)

export default component.exports